import React from 'react'
import { Row, Col } from 'rsuite'
import QualificationResponsinatorTableView from './QualificationResponsinatorTableView'

export default function QualificationResponsibleView({ schema }) {
  const Styles = {
    detail: {
      paddingLeft: 20,
      wordWrap: 'break-word',
    },
    dataPadding: {
      paddingBottom: 10,
    },
  }

  return (
    <>
      <Row>
        {schema.educationHistory && (
          <Col style={Styles.dataPadding}>
            <b>{schema.educationHistory.label}</b>
            {schema.educationHistory.value ? (
              <div
                style={Styles.detail}
                dangerouslySetInnerHTML={{ __html: schema.educationHistory.value }}
              />
            ) : (
              <p style={Styles.detail}> - ไม่ระบุ -</p>
            )}
          </Col>
        )}

        {schema.experience && (
          <Col style={Styles.dataPadding}>
            <b>{schema.experience.label}</b>
            {schema.experience.value ? (
              <div
                style={Styles.detail}
                dangerouslySetInnerHTML={{ __html: schema.experience.value }}
              />
            ) : (
              <p style={Styles.detail}> - ไม่ระบุ -</p>
            )}
          </Col>
        )}

        {schema.expertiseAreas && (
          <Col style={Styles.dataPadding}>
            <b>{schema.expertiseAreas.label}</b>
            {schema.expertiseAreas.value ? (
              <div
                style={Styles.detail}
                dangerouslySetInnerHTML={{ __html: schema.expertiseAreas.value }}
              />
            ) : (
              <p style={Styles.detail}> - ไม่ระบุ -</p>
            )}
          </Col>
        )}
      </Row>
    </>
  )
}
